/* BeefCake × Zesty Snackz launch page: gallery, quantity, add to cart, reveals.
   Every control works without this file; it only enhances. */
(function () {
  document.querySelectorAll('[data-zl]').forEach(function (root) {
    if (root.dataset.zlReady) return;
    root.dataset.zlReady = 'true';

    // Gallery: thumbnails, arrow keys on the thumb row, horizontal swipe.
    var main = root.querySelector('[data-zl-gallery]');
    var slides = main ? Array.prototype.slice.call(main.querySelectorAll('.zl-gallery__img')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-zl-thumb]'));
    function current() { return Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); })); }
    function goTo(index) {
      if (!slides.length) return;
      var next = (index + slides.length) % slides.length;
      root.setAttribute('data-gallery-touched', '');
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === next); });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === next);
        if (i === next) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
      thumb.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var target = (i + (e.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
        goTo(target); thumbs[target].focus();
      });
    });
    if (main && slides.length > 1) {
      var sx = 0, sy = 0;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy)) return;
        goTo(current() + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    // Quantity stepper.
    root.querySelectorAll('[data-zl-qty]').forEach(function (group) {
      var input = group.querySelector('input');
      group.querySelectorAll('[data-zl-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.zlStep));
          input.value = value;
        });
      });
    });

    // Add to cart through the theme's cart drawer; plain form submit is the fallback.
    var live = root.querySelector('[data-zl-live]');
    root.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM' || (form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      if (!window.BCJCartEntrypoints) return;
      var data = new FormData(form);
      if (!data.get('id')) return;
      var button = form.querySelector('[type="submit"]');
      var feedback = form.querySelector('[data-zl-feedback]');
      var label = button ? button.innerHTML : '';
      e.preventDefault();
      if (feedback) { feedback.hidden = true; feedback.textContent = ''; }
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = 'Adding…'; }
      if (live) live.textContent = 'Adding the bundle to your cart.';
      window.BCJCartEntrypoints.add(data, { source: 'zesty-launch' }).then(function () {
        if (button) { button.setAttribute('aria-busy', 'false'); button.textContent = 'Added to cart'; }
        if (live) live.textContent = 'Added to cart.';
        setTimeout(function () { if (button) { button.innerHTML = label; button.disabled = false; } }, 1600);
      }).catch(function (error) {
        var message = (error && error.message) || 'Could not add to cart. Please try again.';
        if (button) { button.disabled = false; button.setAttribute('aria-busy', 'false'); button.innerHTML = label; }
        if (feedback) { feedback.hidden = false; feedback.textContent = message; }
        if (live) live.textContent = message;
      });
    });

    // Mobile sticky action: show after the main action leaves the viewport, hide at the closing call to action.
    var sticky = root.querySelector('[data-zl-sticky]');
    var mainAction = root.querySelector('.zl-buy [type="submit"], .zl-panel .zesty-signup [type="submit"]');
    var finale = root.querySelector('#zl-final');
    if (sticky && mainAction && 'IntersectionObserver' in window) {
      var mainVisible = true, finaleVisible = false;
      var sync = function () { sticky.hidden = mainVisible || finaleVisible; };
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show whenever the real action is off screen, including below the fold at load, so every phone has an action in view.
          if (entry.target === mainAction) mainVisible = entry.intersectionRatio >= 0.6;
          if (entry.target === finale) finaleVisible = entry.isIntersecting;
        });
        sync();
      }, { threshold: [0, 0.6, 1] }).observe(mainAction);
      if (finale) new IntersectionObserver(function (entries) { finaleVisible = entries[0].isIntersecting; sync(); }).observe(finale);
    }

    // Prelaunch and sold-out links jump to the signup and put the cursor in the email field.
    root.querySelectorAll('[data-zl-focus-signup]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var email = root.querySelector('.zl-panel input[type="email"]');
        if (!email) return;
        e.preventDefault();
        email.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        email.focus({ preventScroll: true });
      });
    });

    // Scroll reveals below the hero.
    var reveals = root.querySelectorAll('[data-zl-reveal]');
    if (reveals.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('is-reveal-ready');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }
  });
})();
